<template>
  <tr>
    <th scope="row">{{ th }}</th>
    <td>
      <template v-for="(item, index) in td.list">
        <a
          :key="`${item.value}_${index}`"
          href="javascript:void(0)"
          class="genre"
          @click.prevent="clickAction(item)"
        >
          {{ isHashAdded ? '#' : '' }}{{ item.text }}
        </a>
        <template v-if="index !== td.list.length - 1">, </template>
      </template>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'TableRowContent',
  props: {
    th: {
      type: String,
      default: ''
    },
    td: {
      type: Object,
      default: null
    }
  },
  computed: {
    isHashAdded () {
      return this.th === '장르'
    }
  },
  methods: {
    clickAction (item) {
      this.$emit('click-fn', item)
    }
  }
}
</script>
